





















































































import Multiselect from 'vue-multiselect'
import { Component, Prop, Vue } from 'vue-property-decorator'
import ExpandIcon from '@/app/ui/assets/expand_icon.vue'
import CloseCircle from '@/app/ui/assets/close_circle_alt.vue'
import SearchIcon from '@/app/ui/assets/ics_o_search.vue'

@Component({
  components: {
    Multiselect,
    ExpandIcon,
    CloseCircle,
    SearchIcon
  },
})
export default class DropdownSelect extends Vue {
  @Prop({ default: () => [] }) private options!: Array<Map<string, unknown>>
  @Prop({ default: false }) private isError!: boolean
  @Prop({ default: 'normal' }) private tagStyle!: 'normal' | 'blue'
  @Prop({ default: false }) private optionSingleLine!: boolean
  @Prop({ default: false }) private isIconSearch!: boolean

  get tagStyleClass(): string {
    if (this.tagStyle !== 'normal') {
      return 'tag-style-' + this.tagStyle
    }

    return ''
  }
}
